(ns frontend.view.components.timeline.entry.task-create
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [frontend.routing :as routing]
  ))

;;TODO update later to jump to actual task instead of task listing
(defn open-task
  [{:keys [audit/target] :as entry}]
  (routing/set-view! [:tasks-grid] {:filter :my-pending}))

(defmethod te/timeline-entry-view :op.task/create
  [{entry :entry}]
  [default/timeline-item-view entry default/title-generator default/body-generator
   default/timestamp-generator
   (fn [] (open-task entry))])
